const REQUEST_TYPES = {
  CONTRATISTA: {
    id: 1,
    name: 'Contratista',
  },
  EMISION_CARNET: {
    name: 'Emisión de Carnet de Empleado',
    id: 2,
  },
  REPOSICION_POR_PERDIDA: {
    id: 3,
    name: 'Reposición por Perdida de Carnet',
  },
  RENOVACION_CARNET: {
    id: 7,
    name: 'Renovación de Carnet de Empleado',
  },
  ESPORADICO: {
    id: 6,
    name: 'Emisión de Carnet Esporádico',
  },
};
// Tipos de solicitud que pueden cancelarse cuando ya fueron pagadas
const CANCELLABLE_REQUEST_TYPES = [
  REQUEST_TYPES.EMISION_CARNET.id,
  REQUEST_TYPES.RENOVACION_CARNET.id,
  REQUEST_TYPES.REPOSICION_POR_PERDIDA.id,
];

const REQUEST_STATUSES = {
  VALIDACION_PENDIENTE: {
    id: 1,
    name: 'Validación pendiente',
  },
  PENDIENTE_PAGO: {
    id: 2,
    name: 'Pendiente de pago',
  },
  EN_PROCESO: {
    id: 3,
    name: 'En proceso',
  },
  PENDIENTE_RETIRO: {
    id: 4,
    name: 'Pendiente retiro',
  },
  PENDIENTE_ACTUALIZACION: {
    id: 5,
    name: 'Pendiente actualización',
  },
  RECHAZADO: {
    id: 6,
    name: 'Rechazado',
  },
  APROBADO: {
    id: 7,
    name: 'Aprobado',
  },
  RETIRO: {
    id: 8,
    name: 'Retirado',
  },
  CANCELADO: {
    id: 9,
    name: 'Cancelado',
  },
  PROCESANDO_PAGO: {
    id: 10,
    name: 'Procesando Pago',
  },
  EN_INVESTIGACION: {
    id: 11,
    name: 'En investigación',
  },
  PENDIENTE_ENVIAR: {
    id: 12,
    name: 'Pendiente de enviar',
    solicitud: 'X',
    contratista: '',
    administration: '',
    depuration: '',
    no_change: 'X',
  },
  CARNET_ESPORADICO_EMITIDO: {
    id: 13,
    name: 'Carnet esporadico emitido',
    solicitud: 'X',
    contratista: 'X',
    administration: 'X',
    depuration: 'X',
    no_change: 'X',
  },
  PENDIENTE_CITA: {
    id: 14,
    name: 'Pendiente de cita',
    solicitud: 'X',
    contratista: 'X',
    administration: 'X',
    depuration: '',
    no_change: '',
    upt_administration: '',
    upt_depuration: '',
  },
  CITA_PROGRAMADA: {
    id: 15,
    name: 'Cita programada',
    solicitud: 'X',
    contratista: 'X',
    administration: 'X',
    depuration: '',
    no_change: '',
    upt_administration: '',
    upt_depuration: '',
  },
  INACTIVO: {
    id: 16,
    name: 'Inactivo',
    solicitud: '',
    contratista: 'X',
    administration: 'X',
    depuration: 'X',
    no_change: 'X',
    upt_administration: '',
    upt_depuration: '',
  },
};

const REQUEST_IDENTIFICATION_TYPES = {
  CEDULA: {
    id: 1,
    name: 'Cédula',
  },
  PASAPORTE: {
    id: 2,
    name: 'Pasaporte',
  },
  RNC: {
    id: 3,
    name: 'RNC',
  },
  FOTO: {
    id: 4,
    name: 'Foto',
  },
};
const REQUEST_DOCUMENT_TYPES = {
  Cédula: {
    id: 1,
    name: 'Cédula',
    for_request: 'X',
  },
  Pasaporte: {
    id: 2,
    name: 'Pasaporte',
    for_request: 'X',
  },
  RNC: {
    id: 3,
    name: 'RNC',
    for_request: 'X',
  },
  Foto: {
    id: 4,
    name: 'Foto',
    for_request: '',
  },
  Visa: {
    id: 5,
    name: 'Visa',
    for_request: '',
  },
  'Carta de denuncia': {
    id: 6,
    name: 'Carta de denuncia',
    for_request: '',
  },
  Contrato: {
    id: 7,
    name: 'Contrato',
    for_request: '',
  },
};

const VALIDITIES = {
  '3_MESES': {
    id: 2,
    name: '3 MESES',
  },
  '1_ANO': {
    id: 3,
    name: '1 AÑO',
  },
  '30_DIAS': {
    id: 4,
    name: '30 dias',
  },
  REIMPRESION_POR_PERDIDA: {
    id: 5,
    name: 'Reimpresion por perdida',
  },
  ESPORADICO_5_DIAS: {
    id: 10,
    name: '5 Días',
  },
  ESPORADICO_3_DIAS: {
    id: 11,
    name: '3 Días',
  },
  ESPORADICO_1_DIA: {
    id: 12,
    name: '1 Día',
  },
};

const MEMBRESIA_MATERIALES = {
  SOL_CONTRATISTA_PERSONA_FISICA: {
    id: 1,
    name: 'Solicitud código contratistas p.física',
  },
  REN_CONTRATISTA_PERSONA_FISICA: {
    id: 2,
    name: 'Renovación código contratista p.física',
  },
  SOL_CONTRATISTA_EMPRESA: {
    id: 3,
    name: 'Solicitud código empresas contratistas',
  },
  REV_CONTRATISTA_EMPRESA: {
    id: 4,
    name: 'Renovación código empresas contratistas',
  },
};

const MEMBERSHIP_PAYMENT_TYPES = {
  NEW: 'Emisión de Contratista',
  RENOVATION: 'Renovación de Membresía',
};

const CITA_STATUSES = {
  CONFIRMADA: {
    id: 1,
    name: 'Cita confirmada',
  },
  VENCIDA: {
    id: 3,
    name: 'Cita vencida',
  },

};

// Peso maximo permitido para los documentos que se cargan en las solicitudes.
const MAX_DOCUMENT_SIZE_MB = 5;
const MAX_DOCUMENT_SIZE_BYTES = MAX_DOCUMENT_SIZE_MB * 1024 * 1024;

export default {
  REQUEST_STATUSES,
  REQUEST_TYPES,
  CANCELLABLE_REQUEST_TYPES,
  REQUEST_IDENTIFICATION_TYPES,
  VALIDITIES,
  MEMBRESIA_MATERIALES,
  REQUEST_DOCUMENT_TYPES,
  MEMBERSHIP_PAYMENT_TYPES,
  CITA_STATUSES,
  MAX_DOCUMENT_SIZE_MB,
  MAX_DOCUMENT_SIZE_BYTES,
};
